import { Flex as BaseFlex } from "@chakra-ui/react";

export default BaseFlex;
